import React from "react";
import styles from "./GiftPage.module.scss";
import classNames from "classnames/bind";
import ProductItem from "../../components/ProductItem/ProductItem";
import { useCategoryStore } from "../../stores/categories/useCategoryStore";
import useTranslations from "../../hooks/useTranslations";
import capitalizeFirstLetter from "../../utils/capitalizeFirstLetter";
import { formatKeyAllUpper } from "../../utils/formatKeyAllUpper";
import { usePageSections } from "../../hooks/usePageSections";
import SectionRenderer from "../../components/SectionRenderer/SectionRenderer";

const cx = classNames.bind(styles);

const GiftPage = () => {
  const { categoryGifts: gifts, isLoading } = useCategoryStore();
  const { sections } = usePageSections("gift");
  
  const currentTranslations = useTranslations()
  if (sections?.length) {
    return (
      <div>
        {sections.map((section) => (
          <SectionRenderer key={section.id} section={section} />
        ))}
      </div>
    );
  }
  

  return (
    <div className={cx("container")}>
      <div className={cx("gifts-title")}>
        <h1 className={cx("title")}>{currentTranslations?.menu?.Gifts}</h1>
      </div>
      <div className={cx("list-gifts")}>
        {isLoading ? (
          <p> loading </p> // Component hiển thị loading
        ) : gifts.length > 0 ? (
          gifts.map((item) => (
            <ProductItem
              key={item.id}
              srcImage={item.image?.src}
              productText={currentTranslations?.GiftDropDown?.[formatKeyAllUpper(item.name)] || item.name }
              textType="title"
              href={`/products/category/${capitalizeFirstLetter(item.slug)}`}
              isShowHeart={false}
            />
          ))
        ) : (
          <p className={cx("no-products")}>Hiện chưa có sản phẩm nào.</p>
        )}
      </div>
    </div>
  );
};

export default GiftPage;
